export default __webpack_public_path__ + "static/media/1906.623c10e9.png";